import React from 'react';

export default function PressReleasePage() {
  return (
    <div className="bg-slate-50 min-h-screen py-16 animate-fade-in font-sans">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-xs font-bold uppercase tracking-wider text-blue-600">Newsroom</span>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight leading-none mt-2 mb-4">
            Press Releases
          </h1>
          <p className="text-slate-600 text-sm">
            Recent announcements and company updates from Candor.
          </p>
        </div>

        <article className="bg-white rounded-3xl p-8 border border-slate-200/60 shadow-sm mb-8">
          <header className="mb-4">
            <span className="text-xs font-bold text-emerald-600 bg-emerald-50 px-2.5 py-1 rounded-full uppercase tracking-wider">
              Product Launch
            </span>
            <h2 className="text-2xl font-bold text-slate-950 mt-3 mb-2">
              Proden Technologies Announces Release of Candor Agentic AI IDE
            </h2>
            <p className="text-slate-400 text-xs">Sheridan, WY — June 5, 2026</p>
          </header>

          <div className="text-slate-700 text-sm leading-relaxed space-y-4">
            <p>
              Proden Technologies Incorporated, a pioneer in AI-assisted developer solutions, today announced the public release of the Candor Agentic AI IDE for Data Warehousing.
            </p>
            <p>
              Candor is the only platform in the industry built with deep, native schema awareness. It resolves the core issues of standard text editors by mapping columns and types directly inside data warehouse schemas to compile production-ready ETL pipelines on the first iteration.
            </p>
            <p>
              "Data teams lose hours debugging mismatched types and schemas when using generic AI agents," said a spokesperson for Proden Technologies. "With Candor, we've built a system that understands the active database layout before writing a single block of Python or SQL code."
            </p>
          </div>
        </article>
      </div>
    </div>
  );
}
